import apiClient from '../networking/apiClient';

import { SubscriptionPlansResponse, SubscriptionsResponse } from './types';

async function fetchSubscriptions() {
    const res = await apiClient.v1.get<SubscriptionsResponse>('/subscriptions');
    return res.data;
}

async function fetchSubscriptionsPlans() {
    const responses = await Promise.all([
        await apiClient.v1.get<SubscriptionPlansResponse>(
            '/subscription_plans' + '?platform=ios',
        ),
        await apiClient.v1.get<SubscriptionPlansResponse>(
            '/subscription_plans' + '?platform=android',
        ),
    ]);

    return responses.flatMap((response) => response.data.payload ?? []);
}

export const SubscriptionsAPI = {
    fetchSubscriptions,
    fetchSubscriptionsPlans,
};
